
/**
 * @author <Aniket.P>
 * @description Date utils
 * @copyright Supra International, inc
 */
import moment from 'moment-timezone';
import { ObjectFactory } from '@/config/objectFactory';
export class DateUtils {

    public static readonly FORMAT_DATETIME_AM_PM = 'MM/DD/YYYY hh:mm a z';

    public static readonly FORMAT_DATETIME_AM_PM_12 = 'MM/DD/YYYY hh:mm a z';

    public static readonly FORMATE_DATE = 'MM/DD/YYYY';
    public static readonly DEFAULT_TIMEZONE = 'America/Detroit';
    public static readonly FORMAT_DATETIME_MONTH = 'MMM DD, YYYY';

    public static getCurrentTimeInMillis(): number {
        const timeInMillis = new Date().getTime();
        return timeInMillis;
    }

    public static formatDate(date: any, format?: string, timeZone?: string): string {
        const memberProfile = ObjectFactory.getCacheService().getMemberInfo();
        if (memberProfile && !timeZone) {
            timeZone = memberProfile.timezone;
        }
        if (!format) {
            format = DateUtils.FORMAT_DATETIME_AM_PM;
        }
        if (timeZone && timeZone === 'America/Dawson') {
            timeZone = 'America/Los_Angeles';
        } else if (timeZone && timeZone === 'America/Detroit') {
            timeZone = 'America/New_York';
        } else if (timeZone && timeZone === 'America/Boise') {
            timeZone = 'America/Denver';
        }
        const momentObj = moment.tz(date, timeZone as any);
        const formattedTime = momentObj.format(format);
        return formattedTime;
    }

    public static getDurationText(totalMinutes: number) {
        let durationText = `${totalMinutes} Minutes`;
        if (totalMinutes >= 60) {
            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;
            let hourText = 'Hours';
            let minutesText = 'Minutes';
            if (hours === 1) {
                hourText = 'Hour';
            }
            if (minutes === 1) {
                minutesText = 'Minute';
            }
            durationText = `${hours} ${hourText}`;
            if (minutes > 0) {
                durationText += ` and ${minutes} ${minutesText}`;
            }
        }
        return durationText;
    }

    public static convertMinutesToMillis(minutes: number): number {
        return minutes ? Math.floor(minutes * 60 * 1000) : 0;
    }

    public static convertMillisToMinutes(millis: number): number {
        return millis ? Math.floor(millis / 60000) : 0;
    }

    public static convertToUTCInMillis(dateTime: any, timeZone?: string): number {
        timeZone = timeZone ? timeZone : this.DEFAULT_TIMEZONE;
        if (timeZone && timeZone === 'America/Dawson') {
            timeZone = 'America/Los_Angeles';
        } else if (timeZone && timeZone === 'America/Detroit') {
            timeZone = 'America/New_York';
        } else if (timeZone && timeZone === 'America/Boise') {
            timeZone = 'America/Denver';
        }
        const datetimeWithTimezone = moment.tz(dateTime, timeZone).format(DateUtils.FORMAT_DATETIME_AM_PM);
        const timeInMillis = Date.parse(datetimeWithTimezone);
        return new Date(timeInMillis).getTime();
    }

    public static getLocalTimezone() {
        const memberProfile = ObjectFactory.getCacheService().getMemberInfo();
        return memberProfile && memberProfile.timezone ? memberProfile.timezone : moment.tz.guess();
    }

    public static getCurrentUTCTimeInMillis(): number {
        const timeInMillis = Date.parse(new Date().toUTCString());
        return timeInMillis;
    }

    public static convertMillisToHours(millis: number): number {
        const minutes = this.convertMillisToMinutes(millis);
        return minutes ? Math.floor(minutes / 60) : 0;
    }

    public static getCompletedMonthsFrom(year: number): string[] {
        const lastCompletedMonth = moment().subtract(1, 'month');
        const startMonth = moment(`${year}-01-01`);
        return Array.from({ length: lastCompletedMonth.diff(startMonth, 'months') + 1 }, (_, i) => {
            const monthStart = lastCompletedMonth.clone().subtract(i, 'months').startOf('month');
            const monthEnd = monthStart.clone().endOf('month');
            return `${monthStart.format('MMMM YYYY')} (${monthStart.format('MMMM Do')} to ${monthEnd.format('Do YYYY')})`;
        });
    }

    public static getDateRangeFromMonth(monthStr: string): string {
        const m = moment.utc(monthStr, 'MMMM YYYY', true);
        if (!m.isValid()) {
            return 'Invalid date';
        }
        const firstDay = m.clone().startOf('month');
        const lastDay = m.clone().endOf('month');
        return `${firstDay.format('DD-MM-YYYY')} - ${lastDay.format('DD-MM-YYYY')}`;
    }

}
